module.exports = __webpack_public_path__ + "9fd5d3cae0873e46c589495a270184ff.fbx";